IREP.Webcast = (function () {
    var webcastId;
    var pUid = "";
    var qId = 0;

    var init = function (wid) {
        $("body").addClass("webcastBackground");
        webcastId = wid;
        $("#btnEarnChips").on("click", function () { RedeemPayout(); });
        $("#btnSubmitQuestion").on("click", function () {
            IREP.callApi("webcast/submitquestion", "POST", { question: $("#txtQuestion").val(), queueId: qId });
            $("#txtQuestion").val("");
            $(".thankYou").show();
            setTimeout(function () { $(".thankYou").slideUp(); }, 4000);
        });
        ActivateChecks();
    }

    var RedeemPayout = function () {
        $("#btnEarnChips").fadeOut(250, function () {
            $(".redeemedResponse").slideDown();
            setTimeout(function () { $(".redeemedResponse").slideUp(); }, 4000);
        });

        IREP.callApi("webcast/redeempayout", "POST", {payoutUID:pUid});
    }

    var ActivateChecks = function () {
        checkButton();
        checkQuestions();
    }

    var checkButton = function () {
        setTimeout(function () { checkButton() }, 5000);

        IREP.callApi("webcast/buttonstatus", "GET").done(function (data) {
            if (data.payoutUID != "00000000000000000000000000000000") {
                pUid = data.payoutUID;
                $("#btnEarnChips").fadeIn();
                $("#btnEarnChips").css("display", "inline-block");
            } else {
                pUid = "";
                $("#btnEarnChips").fadeOut();
            }
        });
    }

    var checkQuestions = function () {
        setTimeout(function () { checkQuestions() }, 35000);

        IREP.callApi("webcast/questionstatus", "GET", { webcastId: webcastId }).done(function (data) {
            if (data.queueId != 0) {
                qId = data.queueId;
                $("#submitComments").fadeIn();
            } else {
                qId = 0;
                $("#submitComments").fadeOut();
            }
        });
    }

    return {
        init: init
    };
})();